import { render, staticRenderFns } from "./ModalCertificacoesExistentes.vue?vue&type=template&id=275ecd8c&lang=pug"
import script from "./ModalCertificacoesExistentes.vue?vue&type=script&lang=js"
export * from "./ModalCertificacoesExistentes.vue?vue&type=script&lang=js"
import style0 from "./ModalCertificacoesExistentes.vue?vue&type=style&index=0&id=275ecd8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports